import { render, staticRenderFns } from "./img.vue?vue&type=template&id=71d5724e&scoped=true&"
import script from "./img.vue?vue&type=script&lang=js&"
export * from "./img.vue?vue&type=script&lang=js&"
import style0 from "./img.vue?vue&type=style&index=0&id=71d5724e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d5724e",
  null
  
)

export default component.exports